var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBattery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 8,
    viewBox: "0 0 17 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M11.977.715c.815 0 1.23.094 1.61.297.346.185.617.457.803.803.202.379.297.794.297 1.61h0v.878c0 .815-.095 1.23-.297 1.61-.186.346-.457.617-.803.803-.38.202-.795.297-1.61.297h0-8.54c-.816 0-1.231-.095-1.61-.297-.346-.186-.618-.457-.803-.803-.203-.38-.297-.795-.297-1.61h0v-.878c0-.816.094-1.231.297-1.61.185-.346.457-.618.803-.803.379-.203.794-.297 1.61-.297h0z",
    opacity: 0.35,
    transform: "translate(-1189 -161) translate(1189 161)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M15.867 2.576v2.576c.547-.219.903-.726.903-1.288 0-.563-.356-1.07-.903-1.288",
    opacity: 0.4,
    transform: "translate(-1189 -161) translate(1189 161)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M3.296 1.503h8.821c.595 0 .81.061 1.028.178.217.116.387.286.504.504.116.217.178.432.178 1.027v1.303c0 .595-.062.81-.178 1.028-.117.217-.287.387-.504.504-.218.116-.433.178-1.028.178H3.296c-.594 0-.81-.062-1.027-.178-.218-.117-.388-.287-.504-.504-.116-.218-.178-.433-.178-1.028V3.212c0-.595.062-.81.178-1.027.116-.218.286-.388.504-.504.217-.117.433-.178 1.027-.178z",
    transform: "translate(-1189 -161) translate(1189 161)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.9cf4f974.svg";
export { ForwardRef as ReactComponent };